<script>
	import { isPublicURL, debounce } from '../../services/utils';
	import { onMount } from 'svelte';

	export let form_data;
	export let on_autofill_fetched = () => {};

	let urlInputElement;
	let show_error_url = false;

	function handleBlurPageURL(event) {
		let url = event.target.value.trim();

		show_error_url = false;

		if (!url) return;

		if (url.substring(0, 7) !== "http://" &&
			url.substring(0, 8) !== "https://") {
			url = "https://" + url;
			event.target.value = url;
		}

		if (!isPublicURL(url) && form_data.config.page_url.length > 8) {
			show_error_url = true;
			return;
		}

		// Just validate, the debouce will trigger the API call
	}

	function handleInputPageURL(event) {
		let url = event.target.value.trim();

		if (!url) return;

		if (url.substring(0, 7) !== "http://" &&
			url.substring(0, 8) !== "https://") {
			url = "https://" + url;
		}

		form_data.config.page_url = url;

		if (!isPublicURL(url)) return;

		app.body_spinner.add_to(document.body);

		app.lucep_ai._authenticated_api({
			action: "get_url_profile_scan",
			url: url
		}).then(function(res) {
			if (res.status != "ok" || !res.profile) {
				app.toast_msg.show("This page couldn't be scanned by our AI Agent.");
				return;
			}

			res.profile.page_url = url;
			on_autofill_fetched(res.profile);

		}).catch(function(err){
			console.error(err);
			app.toast_msg.show("Failed to request a scan on the URL. Check your connection.");
		}).finally(function(){
			app.body_spinner.remove();
		});
	}

	const debouncedHandleBlurPageURL = debounce(handleInputPageURL, 1500);

	onMount(() => {

		// It's conflicting with some loading animation, give time before focusing the input
		setTimeout(() => {
			if (form_data.config.page_url && form_data.config.page_url.length > 8) {
				urlInputElement?.select();
			} else {
				form_data.config.page_url = "https://";
				urlInputElement?.focus();
			}
		},500);
	});
</script>
<div>
	<label for="page_url" class="form-label" style="line-height: 1.85rem;">
		Please enter the URL of the <b>project's landing page</b> or a public page that <span class="highlight_text">clearly explains the project's product or service</span>.<br>
		Our <b>Profile Scanner AI Agent</b> will import the suggest settings:
	</label>
	<input bind:this={urlInputElement} bind:value={form_data.config.page_url} on:blur={handleBlurPageURL} on:input={debouncedHandleBlurPageURL} type="url" class="form-control">
	{#if show_error_url}
		<span class="error_url">Please enter a valid public URL.</span>
	{/if}
	<div class="example">
		<div class="mt-3">
			<ul class="upload-restrictions">
				<li>Example: <b>https://www.lucep.com</b> or <b>https://lucep.ai</b></li>
				<li>The page must be accessible for SEO bots.</li>
				<li>The page must be a public page (that doesn't require signing in).</li>
			</ul>
		</div>
	</div>
</div>
<style>
	.example {
		opacity: 0.5;
		font-size: 0.8rem;
	}
	.error_url {
		color: red;
		font-size: 0.8rem;
		margin-top: 0.5rem;
	}
	.highlight_text {
		background-color: #ede1d3;
	}
</style>